

















































































































































import { IProductType, PROPERTY_TYPES } from '@resclick/data-access';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/mixins/table.mixin';
import { Getter } from 'vuex-class';
import moment from 'moment';
import { i18n } from '@/i18n';
import { compass } from '@resclick/compass';
import CancellationsModal from './cancellations.modal.vue';
import ChangesModal from './changes.modal.vue';

@Component({
  components: {
    CancellationsModal,
    ChangesModal,
  },
})
export default class ChangesCancellationsShell extends Mixins(TableMixin) {
  cancellationsModal = {
    open: false,
    id: '',
  };

  changesModal = {
    open: false,
    id: '',
  };

  changeType(id: string, type: 'NEW' | 'CHANGE') {
    compass
      .do('orders', 'update', {
        params: { orderId: id },
        data: { type },
      })
      .then(() => {
        this.$refs.table.refresh();
      });
  }

  @Getter('user/defaultCurrency') currency!: string;
  columns = [
    { label: '#', name: 'orderNumber', sortable: true, align: 'center' },
    {
      label: 'GENERAL.TYPE',
      name: 'type',
      sortable: true,
      align: 'center',
    },
    {
      label: 'GENERAL.CUSTOMER',
      name: 'customer',
      sortable: true,
      field: (row: any) => `${row.customer?.name || ''} ${row.customer?.surname || ''}`,
    },
    {
      label: 'GENERAL.PRODUCTS',
      name: 'products',
      sortable: true,
      field: (row: any) =>
        row.products?.map((product: IProductType) => {
          if (PROPERTY_TYPES.includes(product.type as any)) {
            return (product as any).property?.name;
          }
        }),
    },
    {
      label: 'GENERAL.AGENT',
      name: 'agent',
      sortable: true,
      field: (row: any) => (row.isOnlineBooking ? 'ONLINE' : `${row.agent?.name} ${row.agent?.surname}`),
    },
    {
      label: 'Buyer',
      name: 'buyer',
      sortable: true,
      field: (row: any) => row.buyer?.name,
    },
    {
      label: 'GENERAL.BOOKING_DATE',
      name: 'bookingDate',
      sortable: true,
      style: 'width:1px',
      align: 'center',
      field: (row: any) => row.bookingDate && moment(row.bookingDate).format('DD/MM/YYYY HH:mm'),
    },
    {
      label: 'GENERAL.CHECK_IN',
      name: 'checkInDate',
      sortable: true,
      style: 'width:1px',
      align: 'center',
      field: (row: any) => {
        const { checkInDate } = row.products.find((product: any) => product.productCategory === 'PROPERTY') || {};
        return checkInDate ? moment(checkInDate).format('DD/MM/YYYY') : '';
      },
    },
    {
      label: 'GENERAL.CHECK_OUT',
      name: 'checkOutDate',
      sortable: true,
      style: 'width:1px',
      align: 'center',
      field: (row: any) => {
        const { checkOutDate } = row.products.find((product: any) => product.productCategory === 'PROPERTY') || {};
        return checkOutDate ? moment(checkOutDate).format('DD/MM/YYYY') : '';
      },
    },
    {
      label: 'GENERAL.AMOUNT',
      name: 'total',
      sortable: true,
      align: 'center',
      style: 'width:1px',
      field: (row: any) =>
        `${this.$formatMoney(row.calculations?.total?.value || 0)} ${row.calculations?.total?.currency || ''}`,
    },

    {
      label: 'GENERAL.REMAINING_COLLECTION',
      name: 'remaining_collection',
      sortable: true,
      style: 'width:1px',
      align: 'center',
      field: (row: any) =>
        `${this.$formatMoney(row.calculations?.remainingCollection?.value || 0)} ${
          row.calculations?.remainingCollection?.currency || ''
        }`,
    },
    { label: 'Tracking', name: 'tracking', sortable: true, align: 'center' },
    { label: 'GENERAL.PAYMENTS', name: 'payments', sortable: true },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  filters = [
    { label: this.$i18n.t('GENERAL.VOUCHER'), type: 'number', fieldName: 'orderNumber' },
    {
      label: this.$i18n.t('GENERAL.BOOKING_DATE'),
      type: 'date-range',
      value: { start: new Date(), end: new Date() },
      fieldName: 'bookingDate',
    },
    { label: this.$i18n.t('GENERAL.NAME'), type: 'text', value: '', fieldName: 'customerName' },

    {
      label: this.$i18n.t('GENERAL.PROPERTY'),
      type: 'selectDynamic',
      value: [],
      optionName: 'name',
      optionValue: 'id',
      useChips: true,
      multiple: true,
      fieldName: 'products.property',
      namespace: 'properties',
      action: 'find',
    },

    {
      label: 'Tracking Status',
      type: 'select',
      fieldName: 'tracking.isActive',
      value: [],
      options: [
        { label: 'All', value: [] },
        { label: 'Not Tracking', value: false },
        { label: 'Only Tracking', value: true },
      ],
    },
  ];

  get query() {
    return {
      populate: [
        { path: 'customer', select: ['name', 'surname'] },
        { path: 'agent', select: ['name', 'surname'] },
        { path: 'products.property', select: ['name'] },
        { path: 'buyer', select: ['name'] },
        { path: 'payments' },
      ],
      select: ['+calculations'],
      sort: { orderNumber: 'desc' },
      // currency: this.currency,
    };
  }

  getTypeColor(type: string) {
    switch (type) {
      case 'NEW': {
        return 'positive';
      }
      case 'CHANGE': {
        return 'orange';
      }
      case 'CANCEL': {
        return 'negative';
      }
    }
  }

  getPaymentColor(status: string) {
    if (status === 'PENDING') {
      return 'orange';
    } else if (status === 'ACCEPTED') {
      return 'positive';
    } else if (status === 'REJECTED') {
      return 'negative';
    } else {
      return 'primary';
    }
  }

  getProductName(product: IProductType) {
    if (PROPERTY_TYPES.includes(product.type as any)) {
      return (product as any).property?.name;
    }
  }

  @Watch('query.currency')
  onCurrencyChange() {
    this.$nextTick(() => {
      this.$refs.table.refresh();
    });
  }

  exportData() {
    const translatedColumns = this.columns.map((c) => {
      return {
        ...c,
        label: i18n.t(c.label),
      };
    });
    // @ts-ignore
    this.$refs.table.exportTable(translatedColumns);
  }

  openCancellationsModal(id = '') {
    this.cancellationsModal.id = id;
    this.cancellationsModal.open = true;
  }

  openChangesModal(id = '') {
    this.changesModal.id = id;
    this.changesModal.open = true;
  }

  async revive(orderId: string) {
    await compass.do('orders', 'revive', {
      params: {
        orderId,
      },
    });

    this.$refs.table.refresh();
  }
}
